/* GTL4Life: the cart bump rule (09_apps/cart-bump/README.md).
   The bump itself is the theme's „Product upsells“ block in the cart drawer: on the Deep Sleep page it adds the hidden
   „Лепенки за нос (−15%)“, on the nose strips page the hidden „Deep Sleep (−15%)“. This script keeps the cart honest:
   - a bump stays only while its main product is in the cart, and at most one of it;
   - with a bump in the cart, one free „Лепенки за уста (подарък)“ is added; without one it is removed;
   - in the Sendica order form, quantity buttons are hidden when the order has a bump (the form keeps its own copy of
     the cart, so removing the main product there could not be undone by the rule).
   It works by watching the theme's own cart requests: after each one it reads /cart.js and, when needed, fixes the cart
   in one /cart/update.js call that asks for the same re-drawn sections, so the drawer shows the fixed cart at once.
   Any error leaves the original response untouched. Config (variant ids) comes from layout/theme.liquid: window.gtlBump. */
(function () {
  var cfg = window.gtlBump;
  if (!cfg || !cfg.gift || !cfg.pairs || !window.fetch || window.gtlBumpReady) return;
  window.gtlBumpReady = true;

  var nativeFetch = window.fetch.bind(window);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?$/;
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function plan(cart) {
    var qty = {};
    cart.items.forEach(function (item) { qty[item.variant_id] = (qty[item.variant_id] || 0) + item.quantity; });
    var updates = {}, gift = 0, changed = false;
    cfg.pairs.forEach(function (pair) {
      var has = qty[pair.bump] || 0;
      var keep = (qty[pair.main] || 0) > 0 ? Math.min(has, 1) : 0;
      if (has !== keep) { updates[pair.bump] = keep; changed = true; }
      if (keep > 0) gift = 1;
    });
    if ((qty[cfg.gift] || 0) !== gift) { updates[cfg.gift] = gift; changed = true; }
    return changed ? updates : null;
  }

  function requestedSections(init) {
    var body = init && init.body, sections = null, url = null;
    try {
      if (typeof body === 'string') {
        var data = JSON.parse(body);
        sections = data.sections; url = data.sections_url;
      } else if (body && typeof body.get === 'function') { // FormData / URLSearchParams
        sections = body.get('sections'); url = body.get('sections_url');
      }
    } catch (e) { return null; }
    if (!sections) return null;
    return { sections: sections, sections_url: url || window.location.pathname };
  }

  // The bump card shows only while its main product is in the cart: <html> carries gtl-has-<variant id> classes for
  // the main products, and the card's container is hidden without its class (a toggle there could do nothing).
  var style = document.createElement('style');
  style.setAttribute('data-gtl-bump', '');
  style.textContent = cfg.pairs.map(function (pair) {
    return 'html:not(.gtl-has-' + pair.main + ') .upsells-container:has([data-id="' + pair.bump + '"]){display:none!important}';
  }).join('');
  document.head.appendChild(style);

  function markMains(cart) {
    var present = {};
    cart.items.forEach(function (item) { present[item.variant_id] = true; });
    cfg.pairs.forEach(function (pair) {
      document.documentElement.classList.toggle('gtl-has-' + pair.main, !!present[pair.main]);
    });
  }

  function readCart() {
    return nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { markMains(cart); return cart; });
  }

  function applyPlan(updates, sections) {
    var body = { updates: updates };
    if (sections) { body.sections = sections.sections; body.sections_url = sections.sections_url; }
    return nativeFetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', headers: JSON_HEADERS, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart update ' + r.status); return r.json(); });
  }

  function enforce(response, path, init) {
    if (!response.ok) return Promise.resolve(response);
    return readCart().then(function (cart) {
      var updates = plan(cart);
      if (!updates) return response;
      return applyPlan(updates, requestedSections(init)).then(function (fixed) {
        return response.clone().text().then(function (text) {
          var original = JSON.parse(text), out;
          if (/\/cart\/add/.test(path)) { // the added item(s) stay; only the drawn sections are swapped
            out = original;
            if (fixed.sections) out.sections = fixed.sections;
          } else { // change / update / clear answer with the cart itself
            out = fixed;
          }
          return new Response(JSON.stringify(out), {
            status: response.status, statusText: response.statusText, headers: response.headers
          });
        });
      });
    });
  }

  window.fetch = function (input, init) {
    var pending = nativeFetch(input, init);
    var path;
    try {
      path = new URL(typeof input === 'string' ? input : input.url, window.location.href).pathname;
    } catch (e) { return pending; }
    if (!CART_WRITE.test(path)) return pending;
    return pending.then(function (response) {
      return enforce(response, path, init).catch(function () { return response; });
    });
  };

  // A cart changed outside the drawer (another tab, the /cart page): fix it once on load and redraw the drawer.
  readCart().then(function (cart) {
    var updates = plan(cart);
    if (!updates) return;
    return applyPlan(updates, null).then(function () {
      var items = document.querySelector('cart-drawer-items');
      if (items && typeof items.onCartUpdate === 'function') items.onCartUpdate();
      else if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    });
  }).catch(function () {});

  // The Sendica order form: no quantity changes when the order has a bump.
  var LOCK_CSS = ':host(.gtl-bump-locked) .line-ctl{display:none!important}';
  function lockSendica(host, tries) {
    if (!host || host.dataset.gtlBump) return;
    if (!host.shadowRoot) { // the form attaches its shadow root a moment after it is added
      if ((tries || 0) < 20) setTimeout(function () { lockSendica(host, (tries || 0) + 1); }, 100);
      return;
    }
    host.dataset.gtlBump = '1';
    var style = document.createElement('style');
    style.setAttribute('data-gtl-bump', '');
    style.textContent = LOCK_CSS;
    host.shadowRoot.appendChild(style);
    readCart().then(function (cart) {
      var bumps = cfg.pairs.map(function (p) { return p.bump; });
      var locked = cart.items.some(function (item) { return bumps.indexOf(item.variant_id) !== -1; });
      host.classList.toggle('gtl-bump-locked', locked);
    }).catch(function () {});
  }
  new MutationObserver(function () { lockSendica(document.getElementById('sendica-popup')); })
    .observe(document.body, { childList: true });
})();
